import { mergeAttributes, Node } from '@tiptap/core';
import { AngularNodeViewRenderer } from 'ngx-tiptap';
import { Injector } from '@angular/core';
import { NodeViewReplyComponent } from './node-view-reply/node-view-reply.component';

export const ReplyNode = (injector: Injector): Node => {
  return Node.create({
    name: 'reply',

    group: 'block',
    atom: false,
    draggable: true,
    content: 'inline*',
    selectable: true,

    addAttributes() {
      return {
        sender: { default: null },
        body: { default: null },
        formattedBody: { default: null },
        date: { default: null },
        senderId: { default: null },
        eventId: { default: null },
        msgtype: { default: 'm.text' },
        fileName: { default: null },
        fileSize: { default: null },
        fileMimetype: { default: null },
        fileUrl: { default: null },
        fileIcon: { default: null }
      };
    },

    parseHTML() {
      return [{ tag: 'app-node-view-reply' }];
    },

    renderHTML({ HTMLAttributes }) {
      return ['app-node-view-reply', mergeAttributes(HTMLAttributes)];
    },

    addNodeView() {
      return AngularNodeViewRenderer(NodeViewReplyComponent, { injector });
    }
  });
};
